import { HttpResponse, HttpService } from '@application/http.service';
import type {
	AddMessagingConversationResult,
	BasketContentsApiModel,
	BasketFileReferenceInput,
	BasketFormAnswer,
	CommitResult,
	CommitSuccessResult,
	FormQuestionAnswer,
	MessagingConversationInput,
} from '@visiba/api-vcs-client-v2';
import { Injectable } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class BasketApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('baskets');
	}

	public getActive(receptionId: number): HttpResponse<number> {
		return this.httpService.get(`${this.baseUri}/active/${receptionId}`);
	}

	public deleteActive(receptionId: number): HttpResponse<unknown> {
		return this.httpService.delete(`${this.baseUri}/active/${receptionId}`);
	}

	public deleteProduct(basketId: number, productId: number): HttpResponse<unknown> {
		return this.httpService.delete(`${this.baseUri}/${basketId}/items/${productId}`);
	}

	public getBasket(basketId: number): HttpResponse<BasketContentsApiModel> {
		return this.httpService.get(`${this.baseUri}/${basketId}`);
	}

	public postMessagingConversation(
		basketId: number,
		data: Partial<MessagingConversationInput>,
	): HttpResponse<AddMessagingConversationResult> {
		return this.httpService.post(`${this.baseUri}/${basketId}/MessagingConversation`, data as unknown as Record<string, unknown>);
	}

	public postReason(basketId: number, basketProductId: number, reason: string): HttpResponse<void> {
		return this.httpService.post(`${this.baseUri}/${basketId}/Item/${basketProductId}/Reason`, {
			Reason: reason,
		});
	}

	public postFiles(basketId: number, basketProductId: number, files: BasketFileReferenceInput[]): HttpResponse<void> {
		return this.httpService.post(
			`${this.baseUri}/${basketId}/Item/${basketProductId}/Files`,
			files as unknown as Record<string, unknown>,
		);
	}

	public getFormAnswers(basketId: number, basketProductId: number, formId: number): HttpResponse<BasketFormAnswer[]> {
		return this.httpService.get(`${this.baseUri}/${basketId}/FormAnswers/${basketProductId}/${formId}`);
	}

	public postFormAnswers(
		basketId: number,
		basketProductId: number,
		formId: number,
		data: FormQuestionAnswer[],
	): HttpResponse<unknown> {
		return this.httpService.post(
			`${this.baseUri}/${basketId}/FormAnswers/${basketProductId}/${formId}`,
			data as unknown as Record<string, unknown>,
		);
	}

	public commit(basketId: number): HttpResponse<CommitResult> {
		return this.httpService.put(`${this.baseUri}/${basketId}/commit`, {});
	}

	public async getCommitStatus(commitJobId: number): HttpResponse<CommitSuccessResult> {
		return this.httpService.get(`${this.baseUri}/commit/${commitJobId}`);
	}
}
